import { apiClient } from "../../api/client";
import type { ApiResponse } from "../../api/response";
import type { Plan } from "../models";
import {
  getStorePlans,
  shouldUseSubscriptionApi,
} from "../data/store";
import { SUBSCRIPTION_API_ENDPOINTS } from "./endpoints";

async function fetchApi<T>(path: string): Promise<T | null> {
  try {
    return await apiClient.get<T>(path);
  } catch {
    return null;
  }
}

export const planRepository = {
  async findAll(): Promise<Plan[]> {
    if (shouldUseSubscriptionApi()) {
      const result = await fetchApi<ApiResponse<Plan[]>>(
        SUBSCRIPTION_API_ENDPOINTS.plans.list
      );
      if (result?.data) return result.data;
    }
    return getStorePlans();
  },

  async findById(id: string): Promise<Plan | null> {
    if (shouldUseSubscriptionApi()) {
      const result = await fetchApi<ApiResponse<Plan>>(
        SUBSCRIPTION_API_ENDPOINTS.plans.byId(id)
      );
      if (result?.data) return result.data;
    }
    return getStorePlans().find((p) => p.id === id) ?? null;
  },

  async findByCode(code: string): Promise<Plan | null> {
    if (shouldUseSubscriptionApi()) {
      const result = await fetchApi<ApiResponse<Plan>>(
        SUBSCRIPTION_API_ENDPOINTS.plans.byCode(code)
      );
      if (result?.data) return result.data;
    }
    return getStorePlans().find((p) => p.code === code) ?? null;
  },
};
